export const UPDATEDMTGRESULTSOBJECT = '@dmtg/updateDMTGResultsObject';

export function setDMTGResultsObject(data) {
    return {
        type: UPDATEDMTGRESULTSOBJECT,
        payload: data
    };
}
